// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GroupFormGeneral__form-dd9d3b {
  flex: 1;
  overflow: auto;
}

.GroupFormGeneral__fields-aad773 {
  padding: 24px 24px 0 24px;
}

.GroupFormGeneral__gap-c41d86 {
  margin-bottom: 16px;
}

.GroupFormGeneral__radio-gap-cfcdb5 {
  margin-top: 32px;
  margin-bottom: 24px;
  padding: 0;
}

.GroupFormGeneral__general-bottom-description-fafeec {
  color: var(--base-80);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  margin: 10px 24px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/components/GroupForm/GroupFormGeneral/GroupFormGeneral.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,cAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,UAAA;AACF;;AAEA;EACE,qBAAA;EACA,4BAAA;EACA,8CAAA;EACA,iBAAA;AACF","sourcesContent":[".form {\n  flex: 1;\n  overflow: auto;\n}\n\n.fields {\n  padding: 24px 24px 0 24px;\n}\n\n.gap {\n  margin-bottom: 16px;\n}\n\n.radio-gap {\n  margin-top: 32px;\n  margin-bottom: 24px;\n  padding: 0;\n}\n\n.general-bottom-description {\n  color: var(--base-80);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  margin: 10px 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `GroupFormGeneral__form-dd9d3b`,
	"fields": `GroupFormGeneral__fields-aad773`,
	"gap": `GroupFormGeneral__gap-c41d86`,
	"radio-gap": `GroupFormGeneral__radio-gap-cfcdb5`,
	"radioGap": `GroupFormGeneral__radio-gap-cfcdb5`,
	"general-bottom-description": `GroupFormGeneral__general-bottom-description-fafeec`,
	"generalBottomDescription": `GroupFormGeneral__general-bottom-description-fafeec`
};
module.exports = ___CSS_LOADER_EXPORT___;
